var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "main" },
      [
        _c(
          "el-card",
          { staticClass: "box-card" },
          [
            _c(
              "validation-observer",
              { ref: "observer", attrs: { tag: "form" } },
              [
                _c(
                  "form",
                  {
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.cadastrarNovaSenha()
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { id: "containerImagens" } }, [
                      _c("div", [
                        _c("img", {
                          staticClass: "logo",
                          attrs: { src: require("@/assets/images/logo.png") }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { attrs: { id: "LineSeparator" } }),
                      _vm._v(" "),
                      _c("div", [
                        _c("img", {
                          staticClass: "logo",
                          attrs: {
                            src: require("@/assets/images/logoAbcPa.png")
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            rules: "required|min:6",
                            name: "senha",
                            mode: "lazy"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      placeholder: "Senha",
                                      id: "input_senha",
                                      type: "password"
                                    },
                                    model: {
                                      value: _vm.senha,
                                      callback: function($$v) {
                                        _vm.senha = $$v
                                      },
                                      expression: "senha"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c("validation-provider", {
                          attrs: {
                            rules: "required|password_confirmation:@senha",
                            name: "confirmarSenha"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      placeholder: "Confirmar senha",
                                      id: "input_confirmar_senha",
                                      type: "password"
                                    },
                                    model: {
                                      value: _vm.confirmarSenha,
                                      callback: function($$v) {
                                        _vm.confirmarSenha = $$v
                                      },
                                      expression: "confirmarSenha"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "item" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "full-width",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: _vm.loading, type: "success" },
                            on: {
                              click: function($event) {
                                return _vm.cadastrarNovaSenha()
                              }
                            }
                          },
                          [
                            !_vm.loading
                              ? _c("span", [_vm._v("Confirmar")])
                              : _c("i", { staticClass: "el-icon-loading" })
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-414830f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-414830f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(unauthenticated)/seguranca/cadastro-senha/cadastro-senha.vue
// module id = null
// module chunks = 